import { useTheme } from '@mui/material/styles';
import { useUserInformationContext } from 'contexts/userContext';
import { updateParty } from 'graphql/parties/mutations';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';
import { useHistory } from 'react-router-dom';
import useAlert from 'utils/alert';

const useOnboardingWelcome = () => {
  const theme = useTheme();
  const history = useHistory();
  const showAlert = useAlert();
  const { t } = useTranslation();
  const { setUserOnboarded } = useUserInformationContext();

  const { mutate: updatePartyMutation, ...responseUpdateParty } = useMutation(updateParty, {
    onSuccess: () => {
      responseUpdateParty.reset();
      setUserOnboarded(true);
      history.replace('/profile');
    },
    onError: () => {
      responseUpdateParty.reset();
      showAlert(t('onboarding:error'), 'error');
    },
  });

  return {
    t,
    theme,
    updatePartyMutation,
  };
};

export default useOnboardingWelcome;
